// extracted by mini-css-extract-plugin
export default {"bottomInfo":"bottominfo_bottomInfo__Cq2ej","infoCard":"bottominfo_infoCard__0sklS"};